/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumAlboConfigurazioneTipoCampoDTOTipo =
  (typeof EnumAlboConfigurazioneTipoCampoDTOTipo)[keyof typeof EnumAlboConfigurazioneTipoCampoDTOTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumAlboConfigurazioneTipoCampoDTOTipo = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  DATE: 'DATE',
  NUMBER: 'NUMBER',
} as const;
